export enum ContourElementType {
    ITEM_GROUP,
    ITEM_PATH,
    ITEM_IMAGE,
    MARGIN_PATH,
    FOAM_PATH,
    ITEM_TEXT
}
